<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini" :inline="true">
                <el-form-item  style="width: 350px" prop="vc_pzname" :label="$t('moveInventory_variety')" required>{{formData.vc_pzname+' '+formData.vc_bzstyle}}</el-form-item>
                <el-form-item  style="width: 350px" prop="vc_gsname" :label="$t('moveInventory_company')" required>{{formData.vc_gsname}}</el-form-item>
                <el-form-item  style="width: 350px" prop="vc_ckname" :label="$t('moveInventory_warehouse')" required>{{formData.vc_ckname}}</el-form-item>
                <el-form-item  style="width: 350px" prop="vc_no" :label="$t('moveInventory_batch_no')" required>{{formData.vc_no}}</el-form-item>
                <el-form-item  style="width: 350px" prop="i_wzid" :label="$t('moveInventory_warehouse_location')" required>{{formData.i_wzid}}</el-form-item>
                <el-form-item  style="width: 350px" prop="i_scid" :label="$t('moveInventory_production_id')" required>{{formData.i_scid}}</el-form-item>
                <el-form-item  style="width: 350px" prop="f_kysl" :label="$t('moveInventory_warehouse_stock_quantity')" required>{{formData.f_kysl}}</el-form-item>
                <el-form-item  style="width: 350px" prop="vc_no_hs" :label="$t('moveInventory_cost_accounting_no')" required>{{formData.vc_no_hs}}</el-form-item>
                <el-form-item  style="width: 350px" prop="i_xtype" :label="$t('moveInventory_type')" required>{{formData.i_xtype==1?$t('moveInventory_switch_to_domestic_sale'):$t('moveInventory_switch_to_export_sale')}}</el-form-item>
<!--                <el-form-item  style="width: 350px" prop="i_gid" label="申请部门" >-->
<!--&lt;!&ndash;                    <span v-if="formData.i_isbankcharges===0">{{formData.vc_bzname}}</span>&ndash;&gt;-->
<!--                    <el-select    class="marr4" @change="changebm" v-model="formData.i_gid" size="small"  filterable placeholder="请选择部门">-->
<!--                        <el-option-->
<!--                                v-for="item in bmList"-->
<!--                                :key="item.i_id"-->
<!--                                :label="item.vc_name"-->
<!--                                :value="item.i_id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item style="width: 350px" class="form-title" prop="f_num" :label="$t('moveInventory_conversion_quantity')" required>
                    <el-input class="changeinput" @change="f_numChange" size="mini" v-model="formData.f_num"></el-input>
                </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 9px">
            <template >
                    <el-button type="primary" @click="saveForm('formRef')" :disabled="disabled" :class="baseerp+'btn'" size="small" >{{$t('button_save')}}</el-button>
            </template>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                bmList:[],
                formData:{f_num:null,vc_pzname:'',f_kysl:'',vc_gsname:'',vc_ckname:'',vc_no:'',i_wzid:'',i_scid:'',i_xtype:'',vc_no_hs:'',i_pzid:'',i_gsid:'',i_ckid:''},
                baseerp:'',
                canEdit:false,
                disabled:false
            }
        },

        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            // this.formData=JSON.parse(JSON.stringify(this.data));
            this.formData.vc_pzname=this.data.vc_pzname;
            this.formData.vc_bzstyle=this.data.vc_bzstyle;
            this.formData.vc_gsname=this.data.vc_gsname;
            this.formData.vc_ckname=this.data.vc_ckname;
            this.formData.vc_no=this.data.vc_no;
            this.formData.i_wzid=this.data.i_wzid;
            this.formData.i_scid=this.data.i_scid;
            this.formData.vc_no_hs=this.data.vc_no_hs;
            this.formData.i_xtype=this.data.i_xtype;
            this.formData.i_pzid=this.data.i_pzid;
            this.formData.i_gsid=this.data.i_gsid;
            this.formData.i_ckid=this.data.i_ckid;
            this.formData.f_kysl=this.data.f_kysl;
            this.formData.i_gid=0;
            // console.log(this.formData,'----------*****------this.formData')
            this.baseerp=baseerp;
            // this.getGroupList('');
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },

            editForm(){
                this.canEdit=false
            },
            saveForm(data){
                this.$refs[data].validate((valid)=>{
                    if(valid){
                        this.switchxtype()
                    }else{
                        return false;
                    }
                })

            },
            cancel(){
                this.$emit('close')
            },
            changebm(){

            },
            f_numChange(){
                if(this.formData.f_num>this.formData.f_kysl){
                    this.$set(this.formDate,'f_num',this.formData.f_kysl)
                    this.$message.warning(this.$t('moveInventory_cannot_be_greater_than_business_available_quantity'))
                }
                if(this.formData.f_num<=0){
                    this.$set(this.formDate,'f_num',null)
                    this.$message.warning(this.$t('moveInventory_cannot_be_0'))
                }
            },
            //公司列表
            async getGroupList(val){
                let param={
                    i_gsid:this.formData.i_gsid,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.bmList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async switchxtype(){
                this.disabled=true
                this.formData.i_xtype_des=this.formData.i_xtype==1?0:1;
                let param=this.formData;
                //console.log('param',param)
                let res=await API.switchxtype(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
        },
    }
</script>

<style lang="scss" scoped>
    /deep/.number .el-input__inner{
        text-align: left !important;
    }
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-around;

    }
    .changeinput{
        width: 200px;
        display: inline-block;
    }
</style>